module.exports = __webpack_public_path__ + "img/tag-icon-4.ef0c9b72.png";